import { motion } from 'motion/react';
import { Camera, Flame, TrendingUp, Zap } from 'lucide-react';
import type { HighlightItem, HighlightKey } from './kudosData';
import { useCalm } from './time';

const LOOK: Record<HighlightKey, { cls: string; Icon: typeof Zap }> = {
  climber: { cls: 'bg-iv-soft text-iv-strong', Icon: TrendingUp },
  fastest: { cls: 'bg-lime-soft text-ink', Icon: Zap },
  streak: { cls: 'bg-lime text-ink', Icon: Flame },
  photo: { cls: 'bg-cart-soft text-ink', Icon: Camera },
};

/** Biggest climber, fastest finger, longest streak, photo finish: the moments of the round, one swipe wide. */
export function HighlightsStrip({ items, delay = 0.9 }: { items: HighlightItem[]; delay?: number }) {
  const reduce = useCalm();
  if (!items.length) return null;
  return (
    <ul aria-label="Highlights" className="-mx-4 flex snap-x gap-2 overflow-x-auto px-4 pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      {items.map((h, i) => {
        const { cls, Icon } = LOOK[h.key];
        return (
          <motion.li key={h.key} data-mine={h.mine ? 'yes' : 'no'}
            initial={reduce ? { opacity: 0 } : { opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: delay + i * 0.09, type: 'spring', stiffness: 420, damping: 28 }}
            className={`flex shrink-0 snap-start items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-semibold ${cls} ${h.mine ? 'outline-2 outline-offset-1 outline-ink' : ''}`}>
            <Icon aria-hidden="true" className="size-4 shrink-0" strokeWidth={2.4} />
            {h.text}
          </motion.li>
        );
      })}
    </ul>
  );
}
